import { EAnalyticsStatus, EMatchingType } from '@enums/campaign-analytics.enum';
import { EPlatformFeature } from '@enums/campaign.enum';
import {
  ICtaKpiStatusApi,
  IKpiAnalyticsApi,
  IPlatformInformationApi,
} from '@interfaces/campaign-analytics-api.interface';
import { ICtaKpiStatus } from '@interfaces/campaign-analytics.interface';

export interface ICampaignAnalyticsFilter {
  platformFeatures: Set<EPlatformFeature>;
  executionStatuses: Set<EMatchingType>;
  startDate: Date | null;
  endDate: Date | null;
  creatorIds: Set<string>;
  ctaTemplateIds: Set<string>;
}

export interface IAnalyticsFilterChangedEvent {
  currentFilter: string;
  currentFilterValue: string;
  previousFilterValue: string;
}

export enum ECampaignDetailsTab {
  contents = 'contents',
  creators = 'creators',
  creatorOverview = 'creator_overview',
  creatorTimeline = 'creator_timeline',
  deliverables = 'deliverables',
  kpiGoals = 'kpi_goals',
  performance = 'performance',
  observations = 'observations',
  overview = 'overview',
}

export const CAMPAIGN_DETAILS_ALL_TABS: ECampaignDetailsTab[] = [
  ECampaignDetailsTab.overview,
  ECampaignDetailsTab.kpiGoals,
  ECampaignDetailsTab.performance,
  ECampaignDetailsTab.deliverables,
  ECampaignDetailsTab.observations,
  ECampaignDetailsTab.contents,
  ECampaignDetailsTab.creators,
];

export interface ICampaignDetailsQueryState<T> {
  data: T | null;
  error: string | null;
  filterSignature: string | null;
  // The filterSignature of the last fetch that actually SUCCEEDED for this tab - set exclusively
  // in each fetch method's success branch, never touched by startQueryState() or by an error
  // handler. filterSignature itself is overwritten optimistically the moment a new fetch starts
  // (see startQueryState), so on a failed fetch it no longer reflects what `data` was actually
  // fetched for; confirmedFilterSignature is what error handling reverts filterSignature to
  // instead. Because it's only ever written on success, it stays correct even if a second (or
  // third) filter change starts and fails before an earlier one's error has been handled - unlike
  // a signature captured once at fetch-start time, it can't be clobbered by an intervening
  // in-flight request that never resolves. See CampaignDetailsStore.handleTabRequestError.
  confirmedFilterSignature: string | null;
  inFlight: boolean;
  lastReceivedAt: number | null;
  requestKey: number;
}

export interface ICampaignDetailsOverviewData {
  ctaKpiStatus: ICtaKpiStatusApi;
}

export interface ICampaignDetailsKpiData {
  kpis: IKpiAnalyticsApi;
  platformFeature: EPlatformFeature;
}

export interface ICampaignDetailsCreator {
  color: string;
  ctaKpiStatus: ICtaKpiStatus;
  icon?: string | null;
  id: string;
  name: string;
  status: EAnalyticsStatus;
  statusKpi: EAnalyticsStatus;
  mergedStatus: EAnalyticsStatus;
  usedPlatforms: IPlatformInformationApi[];
}
